import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "extras" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("extras.title")), 1)
    ]),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extras, (extra, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "price",
          key: index
        }, [
          _createElementVNode("span", null, _toDisplayString(extra.text) + " " + _toDisplayString(extra.amount), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(extra.price.toFixed(2)), 1)
        ]))
      }), 128))
    ])
  ]))
}